export default {
	dueWhenOptions: [
		{
			id: 'completed',
			label: 'Completed',
			isDueDateFromNeeded: true,
			isDueDateToNeeded: true,
		},
		{
			id: 'next_7_days',
			label: 'Next 7 Days',
			isDueDateFromNeeded: false,
			isDueDateToNeeded: false,
		},
		{
			id: 'open',
			label: 'Open',
			isDueDateFromNeeded: false,
			isDueDateToNeeded: false,
		},
		{
			id: 'today_overdue',
			label: 'Today & Overdue',
			isDueDateFromNeeded: false,
			isDueDateToNeeded: false,
		},
		{
			id: 'tomorrow',
			label: 'Tomorrow',
			isDueDateFromNeeded: false,
			isDueDateToNeeded: false,
		},
	],
	assigneeConfig: {
		label: "Assignee",
		pageMode: "edit",
		name: "portfolio",
		subscribe: {
			onCreate: {
				model: "User",
				inputField: "users",
				target: "User",
			},
			onDelete: {
				model: "User",
				inputField: "users",
				target: "User",
			},
		},
		list: {
			hideNewRecordButton: true,
			hideListHeader: true,
			editPath: "users",
			objectName: "user",
			pageTitle: "users",
			pageIcon: "store",
			listQueryId: "searchUsers",
			responseFieldName: "searchUsers",
			createMutationId: "createUser",
			deleteQueryId: "deleteUser",
			isPortfolioAddLogDisabled: true,
			deleteQueryIdField: "id",
			deleteMessageTitle: "Are you sure you want to remove {objectName}?",
			deleteMessageText: "",
			linkRows: false,
			skipCardLayout: true,
			itemActions: [
				{
					class: "md-just-icon md-simple md-warning",
					classAdded: "item.added? 'check_circle' : 'md-warning'",
					icon: "post_add",
					iconAdded: "check_circle",
					click: "handleAddReportPortfolio",
				},
			],
			columns: {
				name: { label: "Name", sortable: true },
				createdAt: { label: "Created", sortable: true },
			},
			perPageOptions: [5, 10, 20, 25, 50],
			defaults: {
				sort: "createdAt",
				sortDir: "desc",
				perPage: 10,
			},
			fuseSearch: null,
			relateRecordInput: {
				name: null,
				description: null,
			},
			relateRecordInputField: null,
			relateRecordRouteField: "id",
			formatResponse: (response) => {
				let result = [];
				if (response && response.searchUsers && response.searchUsers.items.length) {
					response.searchUsers.items.forEach((item) => {
						item.name = `${item.given_name} ${item.family_name}`;
						result.push(item);
					});
				}
				return result;
			},
		},
	},
}
